import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { defineProps, withDefaults } from 'vue/dist/vue'
import router from '@/router'
import { useStore } from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'FastMenuButton',
  props: {
    options: {}
  },
  setup(__props: any) {

const store = useStore()
const userInfo = store.state.login.userInfo

const props = __props

const fastLink = () => {
  if (props.options.link518 && userInfo.empTag == '0') {
    router.push({ path: props.options.link518, query: props.options.query })
  } else {
    router.push({ path: props.options.link, query: props.options.query })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_component_el_button, {
    round: "",
    onClick: fastLink,
    class: "fast-button"
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.options.title), 1)
    ]),
    _: 1
  }))
}
}

})